export const ShareLink = {
	name: 'ShareLink',
	props: {
		popupDims: {
			type: Object,
			default: () => { return { w: 705, h: 350 } }
		},
url: {
	type: String,
			default: ''
},
icon: {
	type: String,
			default: ''
},
	},
methods: {
	share(event) {
		event.preventDefault();

		this.$parent.$emit('open-popup', {
			link: this.url,
			popupDims: this.popupDims
		});
	}
},
template: `
		<li class="list__item">
			<a href="#" @click="share">
				<i :class="['fab', icon]"></i>
			</a>
		</li>
	`
}
